import { useAuthContext } from "../../../contexts/auth-context";
import { LAB_PRICE } from "../../../lib/common/constants";
import { useRouteNavigation } from "../../../lib/common/routes";
import { RouteEnumType } from "../../../lib/types/routes";

type TPricingData = {
    card_name?: string;
    title: string;
    price: string;
    features: string[];
    duration?: string;
    sign_up_form: RouteEnumType;
    tag?: string;
};

const pricingData: TPricingData[] = [
    {
        card_name: "Dental Talent",
        title: "Dental Talent Are Always Free",
        price: "Free",
        features: [
            "Unlimited job opportunities",
            "Access to all job postings",
            "Submit your application directly to top dental employers",
            "Matching suggestions based on your hobbies, interests, and skills, powered by AI",
        ],
        sign_up_form: "signupTech",
        tag: "Free!",
    },
    {
        card_name: "Dental Employer",
        title: "Dental Employers Monthly Subscription",
        price: `$${LAB_PRICE}/month`,
        // duration: `Regular price: $${LAB_PRICE}/month`,
        features: [
            "Direct communication between dental employers and candidates",
            "AI candidate/employer matching feature",
            "Target candidates interested in your area",
            "Dental industry-specific features",
        ],
        sign_up_form: "signupLab",
        tag: "First Month Free 🎁",
    },
];

export const PricingBlade = () => {
    const { navigateRouteClickHandler } = useRouteNavigation();
    const { isLoggedIn } = useAuthContext();

    return (
        <div className="container-fluid bg-light pricing-bg">
            <div className="container">
                <div className="row justify-content-center py-5 p-lg-5">
                    <h1 className="home-title-h1">Simple Pricing</h1>
                    <h4 className="mb-3">
                        <strong>Dental Talent </strong>subscriptions are always{" "}
                        {""}
                        <span className="text-secondary">free!</span>
                    </h4>
                    <h4 className="mb-4">
                        <strong>Dental Employers</strong> get full access for{" "}
                        <strong>${LAB_PRICE}/month</strong> — first month on us!
                    </h4>

                    <div className="gap-5 card-group">
                        {pricingData.map((plan, _index) => (
                            <div className="card shadow border-0 rounded">
                                <div className="pb-3">
                                    <h4 className="text-end mt-3">
                                        {" "}
                                        <span
                                            className={`badge rounded-0 rounded-start px-4 ms-4 text-wrap shadow  ${
                                                plan.card_name ===
                                                "Dental Employer"
                                                    ? "text-bg-warning"
                                                    : "text-bg-dark"
                                            }`}
                                        >
                                            {plan.tag}
                                        </span>
                                    </h4>
                                </div>
                                <div className="px-4 px-md-5 pb-3 card-body">
                                    <h2 className="text-info fw-bold highlighted-title pb-3">
                                        {plan.card_name} Subscription
                                    </h2>
                                    <h1 className="fw-bold">{plan.price}</h1>
                                    {/* <h6 className="fw-semibold">
                                        {plan.duration}
                                    </h6> */}
                                    <div style={{ minHeight: "9rem" }}>
                                        <ul className="mt-4">
                                            {plan.features.map((feature, i) => (
                                                <li key={i}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-footer d-lg-flex d-inline-grid gap-md-3 gap-4 px-md-5 py-4 bg-white rounded-bottom border-0">
                                    <button
                                        className="btn btn-info w-100 fw-bold"
                                        onClick={(e) =>
                                            navigateRouteClickHandler(
                                                "pricing",
                                                e
                                            )
                                        }
                                    >
                                        See more
                                    </button>
                                    {!isLoggedIn && (
                                        <button
                                            className="btn btn-info w-100 fw-bold"
                                            onClick={(e) =>
                                                navigateRouteClickHandler(
                                                    plan.sign_up_form,
                                                    e
                                                )
                                            }
                                        >
                                            {plan.card_name} Sign Up
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
